import {useState} from "react";
import {calculatePriceBreakdown, OrderForm, processOrder} from "./orderAPI";
import {globalMessageHandler, Rules, ValidationErrors, Validator} from "../../../common";
import I18n from "i18n-js";

function validateOrderForm(values: OrderForm) {
  const rules: Rules = {
    firstName: Validator.rule.string().required(),
    lastName: Validator.rule.string().required(),
    street: Validator.rule.string().required(),
    city: Validator.rule.string().required(),
    country: Validator.rule.string().required(),
    state: Validator.rule.string().required(),
    zip: Validator.rule.string().required(),
    phone: Validator.rule.string().required(),
  };
  return Validator.validate(rules, values, "OrderForm");
}

export default function useOrderForm() {
  const [item, setItem] = useState<OrderForm>({} as OrderForm);
  const [errors, setErrors] = useState<ValidationErrors>({});
  const [loading, setLoading] = useState(false);
  const [priceBreakdown, setPriceBreakdown] = useState<Record<string, any>>({});

  async function loadPriceBreakdown(id: string|number) {
    const response = await calculatePriceBreakdown(id);

    if (response.success) {
      setPriceBreakdown(response.data.data);
    }
  }

  async function processForm() {
    setLoading(true);

    const result = validateOrderForm(item);
    setErrors(result.errors);

    if (!result.success) {
      setLoading(false);
      return;
    }

    const response = await processOrder(item);
    if (response.success) {
      globalMessageHandler.success(I18n.t("MyAccount.pages.order.orderSuccess"));
    } else {
      globalMessageHandler.error(I18n.t("MyAccount.pages.order.orderError"));
    }
    setLoading(false);
  }

  function onChange(values: OrderForm) {
    setItem(values);
  }

  return {
    processForm,
    priceBreakdown,
    loading,
    item,
    errors,
    onChange,
    loadPriceBreakdown,
  }
}